module.exports = VGS;